// extracted by mini-css-extract-plugin
export default {"popupHeader":"TableRowSelectionPopup_popupHeader__w9sPl","popupBody":"TableRowSelectionPopup_popupBody__dbPFx","bodyRow":"TableRowSelectionPopup_bodyRow__dG9qO"};